﻿import * as $ajax from './_ajax'
import * as $modal from './_modal'
import * as $msg from './_msg'
import * as $types from './_types'

export interface IInitOptions {
    pageName: string
    pagePrefix: string
}

export const loadBlogPostModal = (id: string | number, callback: any) => {
    $modal.load('/Blog/BlogPostModal', { id }, false, true, false, callback)
}

export const saveDontShowAgain = (id: string | number, callback: any) => {
    $ajax.post({
        loadingText: 'Stänger...',
        url: '/Blog/BlogPostHide',
        data: {
            id,
        },
        success: (res: $types.object.IJsonResult) => {
            if (res.Ok) {
                callback()
            } else {
                $msg.showError(res.Message)
            }
        },
    })
}

export const saveInteresting = (id: string | number, callback: any) => {
    $ajax.post({
        loadingText: 'Sparar...',
        url: '/Blog/BlogPostOfInterest',
        data: {
            id,
        },
        success: (res: $types.object.IJsonResult) => {
            if (res.Ok) {
                callback()
            } else {
                $msg.showError(res.Message)
            }
        },
    })
}

export const saveHidden = (id: string | number, callback: any) => {
    $ajax.post({
        loadingText: 'Sparar...',
        url: '/Blog/BlogPostHide',
        data: {
            id,
            toggle: true,
        },
        success: (res: $types.object.IJsonResult) => {
            if (res.Ok) {
                callback()
            } else {
                $msg.showError(res.Message)
            }
        },
    })
}
